import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Divider from 'common-ui-components/dist/components/Atoms/Divider';
import './OrderSummaryMiniCart.scss';
import OrderSummaryLineItem from '../OrderSummaryLineItem';
import OrderSummaryButtons from '../OrderSummaryButtons';

const OrderSummaryMiniCart = ({
  className,
  labels,
  data,
  onSignInAndCheckOut,
  userState,
  signInUrl,
  continueShoppingUrl,
  checkoutButtonDisabled,
  openBlockedAccountModal,
  isAccountBlocked,
  checkoutUrl,
  documentIconUrl,
  isCommerceCheckoutButtonHide,
  includeTaxWithPrice,
  userAuthentication,
}) => (
  <div className={`order-summary-mini-cart ${className}`} data-locator="order-summary-mini-cart">
    <Divider type="h-large" className="order-summary-large-divider" />
    <OrderSummaryLineItem
      priceLabel={
        includeTaxWithPrice && !isEmpty(data.totalPriceWithTax)
          ? labels.cartOrderTotal
          : labels.preOrderTotal
      }
      price={
        includeTaxWithPrice && !isEmpty(data.totalPriceWithTax)
          ? data.totalPriceWithTax
          : data.totalPrice
      }
      isOrderTotal
      className="order-summary-mini-cart"
      elementLocator="mini-cart-total-price-with-tax"
    />
    <OrderSummaryButtons
      isMiniCart
      onSignInAndCheckOut={onSignInAndCheckOut}
      labels={labels}
      userState={userState}
      signInUrl={signInUrl}
      continueShoppingUrl={continueShoppingUrl}
      checkoutButtonDisabled={checkoutButtonDisabled}
      signInButtonElementLocator="button-mini-order-summary-sign-in-and-checkout"
      checkoutLinkElementLocator="link-mini-checkout-to-continue"
      openBlockedAccountModal={openBlockedAccountModal}
      isAccountBlocked={isAccountBlocked}
      checkoutUrl={checkoutUrl}
      documentIconUrl={documentIconUrl}
      isCommerceCheckoutButtonHide={isCommerceCheckoutButtonHide}
      userAuthentication={userAuthentication}
    />
  </div>
);

OrderSummaryMiniCart.propTypes = {
  className: PropTypes.string,
  onSignInAndCheckOut: PropTypes.func,
  labels: PropTypes.shape({
    preOrderTotal: PropTypes.string,
    signInAndCheckOut: PropTypes.string,
    continueToCheckout: PropTypes.string,
    cartOrderTotal: PropTypes.string,
  }),
  data: PropTypes.shape({
    totalPrice: PropTypes.string,
    totalPriceWithTax: PropTypes.string,
  }),
  userState: PropTypes.string.isRequired,
  signInUrl: PropTypes.string,
  continueShoppingUrl: PropTypes.string,
  checkoutButtonDisabled: PropTypes.bool,
  openBlockedAccountModal: PropTypes.func,
  isAccountBlocked: PropTypes.bool,
  checkoutUrl: PropTypes.string,
  documentIconUrl: PropTypes.string,
  isCommerceCheckoutButtonHide: PropTypes.bool,
  includeTaxWithPrice: PropTypes.bool,
  userAuthentication: PropTypes.func,
};

OrderSummaryMiniCart.defaultProps = {
  className: '',
  onSignInAndCheckOut: () => {
    /* default onSignInAndCheckOut handler */
  },
  labels: {
    preOrderTotal: '',
    cartOrderTotal: '',
  },
  data: { totalPrice: '--,--', totalPriceWithTax: '--,--' },
  signInUrl: '',
  continueShoppingUrl: '',
  checkoutButtonDisabled: PropTypes.bool,
  openBlockedAccountModal: () => {
    /* default openBlockedAccountModal handler */
  },
  userAuthentication: () => {
    /* default userAuthentication handler */
  },
  isAccountBlocked: false,
  checkoutUrl: '#',
  documentIconUrl: '',
  isCommerceCheckoutButtonHide: false,
  includeTaxWithPrice: false,
};

export default OrderSummaryMiniCart;
